import { render, staticRenderFns } from "./MainImage.vue?vue&type=template&id=09b4e186"
import script from "./MainImage.vue?vue&type=script&lang=js"
export * from "./MainImage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports